import React from "react";
import { Spinner } from "react-bootstrap";
import styled from "styled-components";

const SpinnerContainer = styled.div<{ top: number, width: number, height: number }>`

    text-align: center;
    position: absolute;
    left: 0;
    top: ${props => props.top}px;
    width:100%;
    z-index:1050;

   .spinner-border {
        display: inline-block;
        position:relative;
        width: ${props => props.width}rem;
        height: ${props => props.height}rem;
        vertical-align: text-bottom;
        border: .25em solid;
        border-right: .25em solid transparent;
        border-radius: 50%;
        -webkit-animation: spin .75s linear infinite;
        animation: spin .75s linear infinite;
    }

    @-webkit-keyframes spin {
      from {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }
      to {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
      }
    }
    @keyframes spin {
      from {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }
      to {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
      }
    }
`;

export default ({ spinner, variant = "primary", top = 160, width = 10, height = 10 }) => {
    if (spinner) {
        return (
            <SpinnerContainer top={top} width={width} height={height}>
                <Spinner animation="border" variant={variant} />
            </SpinnerContainer>
        );
    }
    return null;
};